import styled from 'styled-components'
import { Box } from 'grid-styled'
import media from 'styles/tools/media'
import rem from 'styles/tools/rem'
import { darkGrey } from 'styles/settings/colors'
import { txt14OpenSans } from 'styles/settings/types'

export const Teste = styled.div``

export const ItemDescription = styled.p`
  ${txt14OpenSans} white-space: normal;
  color: ${darkGrey};
  margin: 0 0 ${rem('37px')} 0;

  ${media.large`
    max-width: ${rem('184px')};
  `};
`

export const List = styled(Box)`
  margin-top: ${rem('30px')};
  max-width: ${rem('184px')};

  &:last-child {
    max-width: 100%;
  }

  ${media.large`
    margin-right: ${rem('30px')};
    max-width: ${rem('230px')};
  `};
`



// WEBPACK FOOTER //
// ./src/app/modules/IconTextCarousel/styles.js